import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { LoginService } from './services/login.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [LoginService]
})
export class AppComponent {
    public settings: Settings;
    public userLoginService: LoginService
    constructor(public appSettings:AppSettings, private router:Router, private http: HttpClient){
        this.settings = this.appSettings.settings;  
    }    

    @HostListener('document:click', ['$event'])
    checkUser(){
      if(JSON.parse(localStorage.getItem('ngx_user')) != null){
        let user = JSON.parse(localStorage.getItem('ngx_user'));
        let url = JSON.parse(localStorage.getItem('ngx_url'));

        if(user.status == 1){
          this.http.get(url.rest + '/tms/getMemberById/' + user.id).subscribe(
            data => {
              if(data['member'][0].status == 0){
                this.router.navigate(['logout']);
              }
            }
          );
        }
        else{
          this.router.navigate(['logout']);
        }
      }
    }
}
